/**
 * Enum com os tipos de benefícios mais comuns no Brasil
 */
export enum BenefitType {
  VALE_REFEICAO = 'Vale Refeição',
  VALE_ALIMENTACAO = 'Vale Alimentação',
  VALE_TRANSPORTE = 'Vale Transporte',
  AUXILIO_COMBUSTIVEL = 'Auxílio Combustível',
  AUXILIO_EDUCACAO = 'Auxílio Educação',
  AUXILIO_SAUDE = 'Auxílio Saúde',
  AUXILIO_ODONTOLOGICO = 'Auxílio Odontológico',
  PLANO_SAUDE = 'Plano de Saúde',
  PLANO_ODONTOLOGICO = 'Plano Odontológico',
  SEGURO_VIDA = 'Seguro de Vida',
  PARTICIPACAO_LUCROS = 'Participação nos Lucros',
  PREMIO_PRODUCAO = 'Prêmio de Produção',
  COMISSAO = 'Comissão',
  BONUS = 'Bônus',
  ADIANTAMENTO_SALARIAL = 'Adiantamento Salarial',
  AUXILIO_CRECHE = 'Auxílio Creche',
  AUXILIO_MORADIA = 'Auxílio Moradia',
  AUXILIO_ALIMENTACAO = 'Auxílio Alimentação',
  OUTROS = 'Outros'
}

/**
 * Array com as opções de benefícios para uso em selects
 */
export const BENEFIT_TYPE_OPTIONS = [
  { value: BenefitType.VALE_REFEICAO, label: BenefitType.VALE_REFEICAO },
  { value: BenefitType.VALE_ALIMENTACAO, label: BenefitType.VALE_ALIMENTACAO },
  { value: BenefitType.VALE_TRANSPORTE, label: BenefitType.VALE_TRANSPORTE },
  { value: BenefitType.AUXILIO_COMBUSTIVEL, label: BenefitType.AUXILIO_COMBUSTIVEL },
  { value: BenefitType.AUXILIO_EDUCACAO, label: BenefitType.AUXILIO_EDUCACAO },
  { value: BenefitType.AUXILIO_SAUDE, label: BenefitType.AUXILIO_SAUDE },
  { value: BenefitType.AUXILIO_ODONTOLOGICO, label: BenefitType.AUXILIO_ODONTOLOGICO },
  { value: BenefitType.PLANO_SAUDE, label: BenefitType.PLANO_SAUDE },
  { value: BenefitType.PLANO_ODONTOLOGICO, label: BenefitType.PLANO_ODONTOLOGICO },
  { value: BenefitType.SEGURO_VIDA, label: BenefitType.SEGURO_VIDA },
  { value: BenefitType.PARTICIPACAO_LUCROS, label: BenefitType.PARTICIPACAO_LUCROS },
  { value: BenefitType.PREMIO_PRODUCAO, label: BenefitType.PREMIO_PRODUCAO },
  { value: BenefitType.COMISSAO, label: BenefitType.COMISSAO },
  { value: BenefitType.BONUS, label: BenefitType.BONUS },
  { value: BenefitType.ADIANTAMENTO_SALARIAL, label: BenefitType.ADIANTAMENTO_SALARIAL },
  { value: BenefitType.AUXILIO_CRECHE, label: BenefitType.AUXILIO_CRECHE },
  { value: BenefitType.AUXILIO_MORADIA, label: BenefitType.AUXILIO_MORADIA },
  { value: BenefitType.AUXILIO_ALIMENTACAO, label: BenefitType.AUXILIO_ALIMENTACAO },
  { value: BenefitType.OUTROS, label: BenefitType.OUTROS }
];

